module.exports = __webpack_public_path__ + "img/18a001-06.e7459899.png";